import { useEffect, memo } from 'react';
import { createPortal } from 'react-dom';

let dragposition = '';

const Portal = memo(({ children }) => {
  const mount = document.getElementById('mainmenu-chatbot');
  let el = document.getElementById('chatbot-content');
  if (!el) {
    el = document.createElement('div');
    el.setAttribute('id', 'chatbot-content');
  }
  
  useEffect(() => {
    console.log('mounted', dragposition);
    mount.appendChild(el);
    if (dragposition) {
      $('.draggable-chatbot-wrapper').css(dragposition);
    }
    setTimeout(() => {
      $('.draggable-chatbot-wrapper').draggable({
        containment: 'document',
        cancel: '.kr-data-scale-range',
        drag: (event, ui) => {
          console.log("drag")
          dragposition = ui.position;
        },
        iframeFix: true,
      });
    }, 100);
    return () => mount.removeChild(el);
  }, [mount, el]);


  return createPortal(children, el)
});

export default Portal;